import type { Account } from "@/features/accounts/types";

/**
 * AccountDto carries no name today, so an account is described by what the
 * user can actually recognise: its currency, or its rank when there are several.
 */
export function accountLabel(account: Account, index = 0): string {
  if (account.name) return account.name;
  return index === 0 ? "Compte principal" : `Compte ${index + 1}`;
}
